import {
  FileToShare,
  FileTypes,
  ListOfBasicUsersInfo,
  PermissionTypes,
  ShareFilesDialogComponent,
  UserBasicInfo,
} from '@dntlab/share-files-dialog';
import AppSettings from 'src/app/common/app.settings';
import { AccountStatus, FileDescriptor, FullUser, ListOfBasicUsers } from 'src/app/swagger-api';
import { allTypesFilesMock, fileUser } from './files.mock';

export const sharedComponentMock: () => ShareFilesDialogComponent = () => ({}) as ShareFilesDialogComponent;
export const mockFileDescriptor: FileDescriptor = {
  entity_id: 'testFileId',
  name: 'tool caddy.skp',
  public_url: 'https://storage.com/6e3cb4f834dd0fd/tool%20caddy.skp',
  content_type: null,
  size: 100,
  state: 'valid',
  created: new Date().toISOString().split('T')[0],
  is_public: false,
  modified: new Date().toISOString().split('T')[0],
  creator_account_id: 'testAccountId',
};

export const fileToShareMock: FileToShare[] = [
  {
    file: {
      entityId: allTypesFilesMock[0].entity['entity_id'],
      currentUserId: 'testAccountId',
      name: allTypesFilesMock[0].entity.name,
      publicUrl: allTypesFilesMock[0].entity['public_url'] as string,
      isDirectory: false,
      type: FileTypes.AUDIO,
    },
    security: [{ user: fileUser, permission: PermissionTypes.owner, isCurrentUser: false }],
  },
  {
    file: {
      entityId: allTypesFilesMock[1].entity['entity_id'],
      currentUserId: 'testAccountId',
      name: allTypesFilesMock[1].entity.name,
      publicUrl: allTypesFilesMock[1].entity['public_url'] as string,
      isDirectory: false,
      type: FileTypes.VIDEO,
    },
    security: [{ user: fileUser, permission: PermissionTypes.owner, isCurrentUser: false }],
  },
];

export const fileToShareMockWithIsDirectory: FileToShare[] = [
  {
    file: {
      entityId: allTypesFilesMock[0].entity['entity_id'],
      currentUserId: 'testAccountId',
      name: allTypesFilesMock[0].entity.name,
      publicUrl: allTypesFilesMock[0].entity['public_url'] as string,
      isDirectory: true,
      type: FileTypes.AUDIO,
    },
    security: [{ user: fileUser, permission: PermissionTypes.owner, isCurrentUser: false }],
  },
  {
    file: {
      entityId: allTypesFilesMock[1].entity['entity_id'],
      currentUserId: 'testAccountId',
      name: allTypesFilesMock[1].entity.name,
      publicUrl: allTypesFilesMock[1].entity['public_url'] as string,
      isDirectory: true,
      type: FileTypes.VIDEO,
    },
    security: [{ user: fileUser, permission: PermissionTypes.owner, isCurrentUser: false }],
  },
];

export function fileDescriptorToFileShareAdapter(
  filesDescriptor: FileDescriptor[],
  currentUserId: string,
): FileToShare[] {
  return filesDescriptor.map((fileDescriptor: FileDescriptor) => {
    return {
      file: {
        entityId: fileDescriptor.entity_id,
        currentUserId,
        name: fileDescriptor.name,
        publicUrl: fileDescriptor.public_url,
        isDirectory: false,
      },
      security: [],
    };
  });
}

export function adaptListOfUsers(list: object[]): ListOfBasicUsersInfo[] {
  const adaptedList: UserBasicInfo[] = [];

  for (const userList of list) {
    for (const user of userList['items']) {
      const adaptedUser: UserBasicInfo = {
        user_id: (user as FullUser).user_id,
        displayed_name: (user as FullUser).displayed_name,
        account_status: (user as FullUser).account_status,
        image_url: (user as FullUser).image_url || AppSettings.NO_PHOTO_DEFAULT_IMAGE,
      };
      adaptedList.push(adaptedUser);
    }
  }

  return [{ items: adaptedList }];
}

export const listOfUsers: ListOfBasicUsers = {
  items: [
    {
      user_id: 'userid',
      displayed_name: 'StiveJobs',
      is_admin: false,
      account_status: AccountStatus.ACTIVE,
    },
    {
      user_id: 'userid1',
      displayed_name: 'Morty',
      is_admin: false,
      account_status: AccountStatus.ACTIVE,
    },
  ],
};
